import { render, staticRenderFns } from "./SignatureInputs.vue?vue&type=template&id=6d8cda4a&scoped=true&"
import script from "./SignatureInputs.vue?vue&type=script&lang=js&"
export * from "./SignatureInputs.vue?vue&type=script&lang=js&"
import style0 from "./SignatureInputs.vue?vue&type=style&index=0&id=6d8cda4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8cda4a",
  null
  
)

export default component.exports